import { useCalendarTime } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/CalendarTimeContext";
import DatePicker from "components/date-picker/DatePicker";
import FormControlTime from "components/form-control-time/FormControlTime";
import RequiredAsterisk from "components/required-asterisk";
import messages from "messages";
import moment from "moment-timezone";
import getClasses from "utils/getClasses";
import addToCalendarStyles from "../../../../AddToCalendar.module.scss";

interface SessionDateAndTimeProps {
  dateValue?: number;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
  setDateValue: React.Dispatch<React.SetStateAction<number | undefined>>;
  timeValue?: string;
  setTimeValue: React.Dispatch<React.SetStateAction<string | undefined>>;
  trackClick: (elementName: string) => void;
  canChangeDate: boolean;
}

const DATE_FORMAT = "MM/dd/yyyy";

const SessionDateAndTime = ({
  dateValue,
  setIsDirty,
  setDateValue,
  timeValue,
  setTimeValue,
  trackClick,
  canChangeDate,
}: SessionDateAndTimeProps) => {
  const { currentCalendarTimezone, setAnchorTime } = useCalendarTime();
  return (
    <div className={addToCalendarStyles["row"]}>
      <label className={addToCalendarStyles["label"]}>
        <span className={addToCalendarStyles["label-text"]}>
          {messages.sessiondate}
          <RequiredAsterisk />
        </span>
        {/* date */}
        <DatePicker
          disabled={!canChangeDate}
          placeholderText={DATE_FORMAT.toLowerCase()}
          dateFormat={DATE_FORMAT}
          timezone={currentCalendarTimezone}
          selected={!dateValue ? undefined : new Date(dateValue)}
          onChange={(date: Date) => {
            trackClick("date-picker");
            setAnchorTime(date.valueOf());

            const diffDays = moment(date)
              .tz(currentCalendarTimezone)
              .startOf("day")
              .diff(
                moment(dateValue).tz(currentCalendarTimezone).startOf("day"),
                "day",
              );

            const start = moment(dateValue)
              .tz(currentCalendarTimezone)
              .add(diffDays, "day")
              .toDate()
              .valueOf();
            // bump to min value
            if (start !== dateValue) {
              setIsDirty(true);
            }
            return setDateValue(start);
          }}
        />
      </label>

      <label
        className={getClasses(
          addToCalendarStyles["label"],
          addToCalendarStyles["label--time"],
        )}
      >
        <span className={addToCalendarStyles["label-text"]}>
          {messages.time}
          <RequiredAsterisk />
        </span>
        {/* time */}
        <FormControlTime
          className={addToCalendarStyles["add-to-calendar__time"]}
          value={timeValue ?? ""}
          onChange={(e) => {
            trackClick("time-selector");
            // browsers will only fire when it has a valid time input
            setIsDirty(true);
            setTimeValue(e.target.value);
          }}
        />
      </label>
    </div>
  );
};

export default SessionDateAndTime;
